/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_LocalInputs */

const en_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Storage`)
};

const fr_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage local`)
};

const de_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokaler Speicher`)
};

const it_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione locale`)
};

const ru_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Локальное хранилище`)
};

const es_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento local`)
};

const zh_cn2_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地存储`)
};

const ja_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルストレージ`)
};

const hi_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय भंडारण`)
};

const pt_pt2_media_import_source_local = /** @type {(inputs: Media_Import_Source_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento local`)
};

/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {Media_Import_Source_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_local = /** @type {((inputs?: Media_Import_Source_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_local(inputs)
	if (locale === "de") return de_media_import_source_local(inputs)
	if (locale === "it") return it_media_import_source_local(inputs)
	if (locale === "ru") return ru_media_import_source_local(inputs)
	if (locale === "es") return es_media_import_source_local(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_local(inputs)
	if (locale === "ja") return ja_media_import_source_local(inputs)
	if (locale === "hi") return hi_media_import_source_local(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_local(inputs)
	return en_media_import_source_local(inputs)
});